import { render, staticRenderFns } from "./ClaimContactsInformation.vue?vue&type=template&id=4d1200a4&scoped=true"
import script from "./ClaimContactsInformation.vue?vue&type=script&lang=js"
export * from "./ClaimContactsInformation.vue?vue&type=script&lang=js"
import style0 from "./ClaimContactsInformation.vue?vue&type=style&index=0&id=4d1200a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1200a4",
  null
  
)

export default component.exports